import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

interface Product {
  id: number;
  name: string;
  title: string;
  description: string;
  price: number;
  image_url: string;
  image: string;
  category: string;
  stock: number;
}

interface ProductsState {
  items: Product[];
  loading: boolean;
  error: string | null;
}

const initialState: ProductsState = {
  items: [],
  loading: false,
  error: null,
};

export const fetchProducts = createAsyncThunk('products/fetchProducts', async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get('https://api.missmeg.store/api/admin/products', {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
});

export const updateProduct = createAsyncThunk(
  'products/updateProduct',
  async ({ id, data }: { id: number; data: Partial<Product> }) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(
      `https://api.missmeg.store/api/admin/products/${id}`,
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  }
);

export const createProduct = createAsyncThunk(
  'products/createProduct',
  async (data: Omit<Product, 'id'>) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      'https://api.missmeg.store/api/admin/products',
      data,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  }
);

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch products';
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        const index = state.items.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.items.push(action.payload);
      });
  },
});

export const { clearError } = productsSlice.actions;
export default productsSlice.reducer; 